/*
*
* File JS Principale
*
*/
// IMPORT JQUERY
//--------------------------------------------------------------------//

import $ from 'jquery';


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import 'scss/app.scss';

//--------------------------------------------------------------------//

// Carichiamo i font in maniera asincrona
//--------------------------------------------------------------------//

var Webfont = require('webfontloader');

Webfont.load({
    typekit: {
        id: 'xql0vbc',
    }
});

//--------------------------------------------------------------------//

// Libreria Lazysizes
//--------------------------------------------------------------------//
import 'lazysizes';

//--------------------------------------------------------------------//

// Import Utilies
//--------------------------------------------------------------------//

import { initSvgImage } from './utilities/img-svg';
import smoothScroll from './utilities/smooth-scroll';
import initAnimations from './utilities/animations';

//--------------------------------------------------------------------//


// Init Utilies
//--------------------------------------------------------------------//

initSvgImage();
smoothScroll();
initAnimations();

//--------------------------------------------------------------------//


// Import Componenti
//--------------------------------------------------------------------//


import header from 'components/header/header';
import accordion from 'components/accordion/accordion';
import languageList from 'components/language-list/language-list';
import footer from 'components/footer/footer';

//--------------------------------------------------------------------//


// Init Componenti
//--------------------------------------------------------------------//

header();

accordion();

languageList();

footer();

//--------------------------------------------------------------------//